import React, { ElementType, ReactNode } from 'react';

import classNames from 'classnames';

export interface InjectedStepProps {
  isActiveStep: boolean;
}

export interface StepProps {
  inject?: InjectedStepProps;
  stepIcon?: ElementType;
  children: ReactNode;
}

const Step = ({ inject, children }: StepProps) => {
  //
  // Even though [inject] prop is optional, it will always be defined since
  // it is passed via Stepper children prop injection
  //
  const { isActiveStep } = inject as InjectedStepProps;

  return (
    <div
      className={classNames('w-full px-[1px]', {
        'h-auto mt-4': isActiveStep,
        'h-0 overflow-hidden': !isActiveStep,
      })}
    >
      {children}
    </div>
  );
};

export default Step;
